import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const usePrompt = (
  defaultMessage = "Are you sure you want to leave?",
  defaultIsDirty = false,
  localstorageKey = []
) => {
  const [isDirty, setIsDirty] = useState(defaultIsDirty);
  const [message, setMessage] = useState(defaultMessage);
  const history = useHistory();

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = message;
      }
    };

    const onUnload = () => {
      localstorageKey.forEach((key) => {
        localStorage.removeItem(key);
      });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", onUnload);

    const unblock = history.block((location, action) => {
      if (isDirty) {
        const confirmLeave = window.confirm(message);
        if (confirmLeave) {
          localstorageKey.forEach((key) => {
            localStorage.removeItem(key);
          });
          unblock();
          history.push(location.pathname);
        }
        return false;
      }

      return true;
    });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", onUnload);
      unblock();
    };
  }, [isDirty, message, localstorageKey, history]);

  return {
    isDirty,
    setIsDirty,
    message,
    setMessage,
    PromptComponent: null,
  };
};

export default usePrompt;
